/* eslint-disable max-classes-per-file */

export class ScSearchConfig {
  endpoint: string;
  filterBy: string;
  display: (data: any) => string;
  filters: any[];

  constructor({ endpoint, filterBy, display, filters = [] }) {
    if (!endpoint || !filterBy) {
      throw new Error('Endpoint & FilterBy must be provided!');
    }
    this.endpoint = endpoint;
    this.filterBy = filterBy;
    this.display = display ? display : this._defaultDisplay;
    this.filters = filters;
  }

  private _defaultDisplay = (data: any) => data && data[this.filterBy];
}

export class ScFormlySearchConfig {
  multiple: boolean;
  filters: any[];
  default: any;

  constructor({ multiple, filters }) {
    if (!filters || filters.length === 0) {
      throw new Error('Endpoint & FilterBy must be provided!');
    }

    this.multiple = multiple;
    this.filters = filters;

    this.filters = this.filters.map(filter => ({
      ...filter,
      filters: filter.filters || [],
      endpoint: filter.endpoint,
      filterBy: filter.filterBy,
      display: filter.display ? filter.display : (data: any) => data && data[filter.filterBy]
    }));

    this.default = this.filters[0];
  }
}

export class ScGoogleMapSearchConfig {
  addressLabelText: string;
  placeholderText: string;
  requiredErrorText: string;
  invalidErrorText: string;
  country: string;
  appearance: string;
  type: string;
  configType: string;
  constructor(config: Partial<ScGoogleMapSearchConfig>) {
    if (!config) {
      config = this._defaultConfig();
    }

    this.addressLabelText = config.addressLabelText;
    this.placeholderText = config.placeholderText;
    this.requiredErrorText = config.requiredErrorText;
    this.invalidErrorText = config.invalidErrorText;
    this.country = config.country;
    this.appearance = config.appearance;
    this.type = config.type;
    this.configType = config.configType || 'coords';

    if (!config.country) {
      this.country = this._defaultConfig().country;
    }
    if (!config.addressLabelText) {
      this.addressLabelText = this._defaultConfig().addressLabelText;
    }
    if (!config.placeholderText) {
      this.placeholderText = this._defaultConfig().placeholderText;
    }
    if (!config.invalidErrorText) {
      this.invalidErrorText = this._defaultConfig().invalidErrorText;
    }
    if (!config.appearance) {
      this.appearance = this._defaultConfig().appearance;
    }

    if (!config.type) {
      this.type = this._defaultConfig().type;
    }
  }

  private _defaultConfig() {
    return {
      addressLabelText: 'Search',
      placeholderText: 'Enter an address',
      requiredErrorText: 'Address is required',
      invalidErrorText: 'Addres is invalid',
      country: 'BG',
      appearance: 'outline',
      type: 'coords'
    };
  }
}
